// src/pages/TeachableHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const TeachableHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Upskilling");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/teachable");
  };

  const groupNames = [
    { label: "Upskilling", emoji: "📚" },
    { label: "Productivity & Content", emoji: "⚡" },
    { label: "Bloom's Room", emoji: "🌸" },
    { label: "Rubric Hub", emoji: "📊" },  
    { label: "AI Zone", emoji: "🤖" },  
    { label: "Student Zone", emoji: "🏛️" },
    { label: "Self Reflection", emoji: "🪞" },
    { label: "Community & New Pedagogy", emoji: "👥" },
    { label: "Teachable Adoption", emoji: "🧗" },
    ];

    // FULL DeepTeach Menu Buttons
    const menuButtons1 = [
    // 📚 Learning & Development
    { label: "Success Kit", emoji: "🧰", link: "/startupkit", group: "Upskilling" },
    { label: "Immersive Books", emoji: "📚", link: "/teachablebookworld", group: "Upskilling" },
    { label: "Teachable Monthly", emoji: "🗓️", link: "/teachablebookworld", group: "Upskilling" },
    { label: "Digital Bookshelf", emoji: "📖", link: "/bookshelf", group: "Upskilling" },
    { label: "My Learning Notes", emoji: "📝", link: "/flipbook-home", group: "Upskilling" },
    { label: "Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Upskilling" },
    { label: "Podcast", emoji: "️🎙️", link: "/podcast-mylist", group: "Upskilling" },
    { label: "Ranking", emoji: "🏆", link: "/teacherscore", group: "Upskilling" },
    { label: "Database", emoji: "💾", link: "/teachabledb", group: "Upskilling" },

    // ⚡ Productivity & Content
    { label: "Teacher Digital Card", emoji: "📘", link: "/teachable-digitalcard", group: "Productivity & Content" },
    { label: "DeepThinking Lab", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Productivity & Content" },
    { label: "Goal Board", emoji: "🎯", link: "/teachable-goalboard", group: "Productivity & Content" },
    { label: "Kanban", emoji: "🗂️", link: "/teachable-kanban", group: "Productivity & Content" },    
    { label: "Exam Schedule", emoji: "📆", link: "/exam-schedule", group: "Productivity & Content" },
    { label: "Teacher's Calculators", emoji: "🧮", link: "/deepteach-calculators", group: "Productivity & Content" },
    { label: "Classroom Trackers", emoji: "📈", link: "/ce-tracker", group: "Productivity & Content" },
    { label: "Lesson Planner", emoji: "📅", link: "/lesson-planner", group: "Productivity & Content" },
    { label: "Dictation Drills Desk", emoji: "✏️", link: "/dictabook-home", group: "Productivity & Content" },
    { label: "Learning Resources", emoji: "📚", link: "/learning-home", group: "Productivity & Content" },
    { label: "Tonic Questions", emoji: "❓", link: "/tonic-cafe", group: "Productivity & Content" },
    { label: "Tonic Bulletin", emoji: "📢", link: "/tonic-cafe", group: "Productivity & Content" },

    // 👥 People & Innovation
    { label: "Counselling Desk", emoji: "🛋️", link: "/counselling-list", group: "Community & New Pedagogy" },
    { label: "My Chatbot Content", emoji: "💬", link: "/aicontent-my", group: "Community & New Pedagogy" },
    { label: "My Chats", emoji: "💬", link: "/teacher-chat", group: "Community & New Pedagogy" },
    { label: "My Visual Briefs", emoji: "📋", link: "/visualbrief-myvb", group: "Community & New Pedagogy" },
    { label: "Point of View", emoji: "👁️", link: "/povify-home", group: "Community & New Pedagogy" },
    { label: "My Applauses", emoji: "👏", link: "/applause-hub-home", group: "Community & New Pedagogy" },
    { label: "Introduce Teacher", emoji: "👥📢", link: "/teachable-introduce", group: "Community & New Pedagogy" },

    // 🏛️ Student Zone
    { label: "Attendance", emoji: "📋", link: "/attendance", group: "Student Zone" },
    { label: "Marks", emoji: "📉", link: "/marks", group: "Student Zone" },
    { label: "Feedback", emoji: "💬", link: "/student-feedback", group: "Student Zone" },
    { label: "Topic RCA", emoji: "🔍", link: "/rcas/add", group: "Student Zone" },
    { label: "Study Pattern", emoji: "📊", link: "/studypattern", group: "Student Zone" },
    { label: "Certificates", emoji: "🏅", link: "/certificates", group: "Student Zone" },
    { label: "Reports", emoji: "📄", link: "/student-reports", group: "Student Zone" },
    { label: "Documents", emoji: "📁", link: "/mydiary-home", group: "Student Zone" },
    { label: "Journals", emoji: "📖", link: "/myjournal-home", group: "Student Zone" },
    { label: "Presentation Deck", emoji: "🎴", link: "/visualbrief-vbforme", group: "Student Zone" },
    { label: "Clear The Doubt", emoji: "❓", link: "/my-concerns-list", group: "Student Zone" },
    { label: "Flying On The Wall", emoji: "🦅", link: "/iamflying", group: "Student Zone" },
    { label: "Test Series Desk", emoji: "🧪", link: "/testseries-my", group: "Student Zone" },
    { label: "CAFE Desk", emoji: "☕", link: "/cafe-bulletin", group: "Student Zone" },
    { label: "Handwritten Desk", emoji: "🖊️", link: "/touchbook-home", group: "Student Zone" },
    { label: "Assignment Book", emoji: "📓", link: "/assignments-others", group: "Student Zone" },

    // 🪞 Self Reflection
    { label: "Journals", emoji: "📖", link: "/myjournal-home", group: "Self Reflection" },
    { label: "Diary", emoji: "📔", link: "/mydiary-home", group: "Self Reflection" },
    { label: "Chronicles", emoji: "📜", link: "/life-chronicles-home", group: "Self Reflection" },
    { label: "Extensive RCA", emoji: "🔄", link: "/fives-mylist", group: "Self Reflection" },
    { label: "Sustainability Goal", emoji: "🌍", link: "/coolearth-home", group: "Self Reflection" },
    { label: "Focus Timer", emoji: "⏳", link: "/focus-timer-home", group: "Self Reflection" },

    // 🧗 Teachable Adoption
    { label: "Ladder", emoji: "🪜", link: "/msme-think5whysmaturity", group: "Teachable Adoption" },
    { label: "Stakeholders", emoji: "👨‍💼", link: "/msme-think5whysroles", group: "Teachable Adoption" },
    { label: "Teachable Advisors", emoji: "🤝", link: "/msme-advisors", group: "Teachable Adoption" },

    // 🌸 Bloom's Room
    { label: "Bloom's Room", emoji: "🌸", link: "/bloom-room", group: "Bloom's Room" },

    // 📊 Rubric Hub
    { label: "Rubric Hub", emoji: "📊", link: "/rubric-grading-hub", group: "Rubric Hub" },

    // 🤖 AI Zone
    { label: "AI Evaluations", emoji: "🤖", link: "/aievaluation-list", group: "AI Zone" },
    { label: "My AI Persona", emoji: "🤖", link: "/aipersona-my", group: "AI Zone" },
    { label: "Predictive Learning", emoji: "🔮", link: "/pl-insights", group: "AI Zone" },
];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-gray-950 text-gray-100 font-sans">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-gray-900 border-b border-gray-800 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-xl font-bold text-yellow-200">Teachable</div>
          <div className="text-[11px] text-yellow-200y">Transforming Pedagogy with Blends of Modern Tools!</div>
        </div>

        {/* Desktop user controls */}
        <div className="hidden lg:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-blue-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 w-8 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                Login
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger (w-10) */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="lg:hidden w-8 h-8 flex items-center justify-center text-xl text-blue-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-blue-300 text-xs font-medium">{userName}</div>
              <div className="flex gap-3">
                <button
                  onClick={handleLogout}
                  className="p-2 rounded-md w-8 bg-red-600 hover:bg-red-700"
                >
                  ⏻
                </button>
              </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-blue-300">Login</Link>
            </div>
          )}
        </div>
      )}

      <div className="bg-blue-800 text-white text-xs sm:text-sm py-2">
        <div className="max-w-6xl mx-auto px-3 flex flex-wrap justify-center gap-4">
          <a href="/teachable-about" className="hover:text-yellow-200">💭 About Teachable</a>
          <a href="/teachable-faq" className="hover:text-yellow-200">🤔 FAQ</a>
        </div>
      </div>

      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2  border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs sm:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-blue-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 lg:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-[10px] sm:text-xs font-medium transition bg-transparent hover:bg-blue-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      <footer className="bg-gray-900 border-t border-gray-800 text-gray-400 py-4">
          <div className="flex px-4 text-center lg:text-left lg:justify-between text-xs space-y-2 lg:flex-row">
            <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
            <div className="flex justify-center gap-6 text-emerald-300">
              <Link to="/about-us" className="text-white hover:text-yellow-200">About</Link>
              <Link to="/privacy-policy" className="text-white hover:text-yellow-200">Privacy</Link>
              <Link to="/terms-of-use" className="text-white hover:text-yellow-200">Terms</Link>
              <Link to="/contact-us" className="text-white hover:text-yellow-200">Contact</Link>
            </div>
          </div>
      </footer>
    </div>
  );
};

export default TeachableHome;
